(() => {
  if (window.loomColorPreviewReady) return;
  window.loomColorPreviewReady = true;
  function init(scope) {
    scope.querySelectorAll('[data-loom-color-preview]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const image = root.querySelector('[data-loom-preview-image]');
      const status = root.querySelector('[data-loom-preview-status]');
      const error = root.querySelector('[data-loom-preview-error]');
      const buttons = [...root.querySelectorAll('[data-loom-preview-color]')];
      let request = 0;
      buttons.forEach(button => {
        button.disabled = false;
        button.addEventListener('click', async () => {
          const current = ++request;
          root.setAttribute('aria-busy', 'true');
          error.textContent = '';
          try {
            const next = new Image();
            next.src = button.dataset.src;
            await next.decode();
            if (current !== request) return;
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = next.src;
            image.alt = button.dataset.alt;
            status.textContent = '';
            buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          } catch (_) {
            if (current === request) error.textContent = 'Dit kleurbeeld kon niet laden. Het vorige kleurvoorbeeld blijft zichtbaar.';
          } finally {
            if (current === request) root.removeAttribute('aria-busy');
          }
        });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
